import React, { useContext } from "react";
import OnColorContext from "../../../contexts/OnColorContext";
import isNotEmpty from "../../../utils/isNotEmpty";
import TextAtm from "../../atoms/TextAtm";
import BreakpointVisibilityOrg from "../../organisms/BreakpointVisibilityOrg";
import FlexContainerOrg from "../../organisms/FlexContainerOrg";
import PushOrg from "../../organisms/PushOrg";
import { TableBar, TableBarItem } from "./HorizontalTableMol.styled";
import SortIcon from "./SortIcon";
function HorizontalTableMol(_ref) {
  var configs = _ref.configs,
    activeFilters = _ref.activeFilters,
    tableBar = _ref.tableBar,
    rows = _ref.rows;
  var onColor = useContext(OnColorContext);
  var tableBarColumns = tableBar.columns.map(function (column, index) {
    var isSortable = column.sortData.isEnabled;
    var sortStatus = column.sortData.status;
    var sortOnClick = column.sortData.onClick;
    return /*#__PURE__*/React.createElement(TableBarItem, {
      key: "".concat(column.title, "-").concat(index + 1),
      flexGrow: 1,
      flexShrink: 1,
      flexBasis: "".concat(column.widthPercent, "%"),
      $isSortable: isSortable,
      $isSorted: !!sortStatus,
      $onColor: onColor,
      onClick: sortOnClick
    }, /*#__PURE__*/React.createElement(FlexContainerOrg, {
      gapSpace: 1,
      direction: column.align === "flex-end" ? "row-reverse" : "row",
      justifyContent: column.align !== "flex-end" ? column.align : undefined
    }, /*#__PURE__*/React.createElement(TextAtm, {
      typography: "xsmall2"
    }, column.title), isSortable ? /*#__PURE__*/React.createElement(SortIcon, {
      status: sortStatus
    }) : null));
  });
  return /*#__PURE__*/React.createElement("div", null, configs ? /*#__PURE__*/React.createElement(PushOrg, {
    bottomSpace: {
      small: 4,
      medium: 4,
      large: 5
    },
    hasNoReset: true
  }, configs) : null, isNotEmpty(activeFilters) ? /*#__PURE__*/React.createElement(PushOrg, {
    bottomSpace: {
      small: 4,
      medium: 4,
      large: 2
    },
    hasNoReset: true
  }, activeFilters) : null, /*#__PURE__*/React.createElement(BreakpointVisibilityOrg, {
    from: "large"
  }, /*#__PURE__*/React.createElement(PushOrg, {
    bottomSpace: 1.5,
    hasNoReset: true
  }, /*#__PURE__*/React.createElement(TableBar, null, tableBarColumns))), rows);
}
export default HorizontalTableMol;